import styled, { css } from 'styled-components'

export const ByePageWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    min-height: 15rem;
    background-color: ${theme.colors.light};
  `}
`

export const ByePageIconContainer = styled.div`
  ${({ theme }) => css`
    margin: 1rem;

    svg {
      fill: ${theme.colors.primary.default};
    }
  `}
`

export const ByePageTitleContainer = styled.div`
  text-align: center;
  margin-bottom: 2rem;
`

export const ByePageSubtitleContainer = styled.div`
  text-align: center;

  button {
    text-decoration: none;
    font-size: 1rem;
  }
`
